




















































































































import {Prop, Watch} from "vue-property-decorator";
import {Stored} from 'vue-stored-prop-decorator';
import {Component, Vue} from '@/shared/component';
import {Timeout, WatchObjectProperties} from '@/shared/decorator';

import storeCommande, {CommandeFilter} from '@/stores/modules/commande';
import storeClient from "@/stores/modules/client";

import InputDateFilter from '@/components/Input/DateFilter.vue';
import CrudClientSearch from "@/components/Crud/Client/Search.vue";
import CrudFournisseurSearch from "@/components/Crud/Fournisseur/Search.vue";
import InputBoisType from "@/components/Input/BoisType.vue";
import InputLongueursVente from "@/components/Input/LongueursVente.vue";
import {DateFilterMode} from "@/shared/filter";
import storeFournisseur from "@/stores/modules/fournisseur";
import storeBoisType from '@/stores/modules/boisType';
import storeLongueursVente from '@/stores/modules/longueursVente';
import storePile from "@/stores/modules/pile";

@Component({
	components: {
		InputDateFilter,
		CrudClientSearch,
		InputBoisType,
		InputLongueursVente,
		CrudFournisseurSearch,
	}
})
export default class CrudCommandeFilter extends Vue {

	@Prop({ type: Boolean, default: false}) reduce!: boolean;

	@Stored(() => storeCommande) private page!: number;
	@Stored(() => storeCommande) private filters!: CommandeFilter;

	private storeFournisseur = storeFournisseur
	private storeBoisType = storeBoisType

	private valueFournisseur = null;
	private valueBoisType = null;
	private valueLongueursVente = null;
	private valuePile = null;

	@WatchObjectProperties('filters', CommandeFilter)
	@Timeout()
	private filtersWatcher(): void {
		this.page = 0;
		storeCommande.dispatch('getC', { filters: true });
	}

	public async mounted(): Promise<void> {
	}

	@Watch('type')
	private typeWatcher(): void {
		this.filters.clear();

	}

}
